import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import { Footer } from "@/components/landing/Footer";
import { SeoHead } from "@/components/SeoHead";

export default function NotFound() {
  return (
    <div data-testid="notfound-root" className="relative min-h-screen w-full bg-background text-foreground">
      <SeoHead title="Page Not Found | Sema" description="This page doesn't exist." path="/404" noindex />
      <MarketingNav />
      <main className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center px-6 pt-24 text-center">
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent">404</p>
        <h1 className="mt-5 text-4xl font-semibold tracking-tight sm:text-5xl">This page doesn't exist.</h1>
        <p className="mt-5 max-w-md text-sm leading-relaxed text-muted-foreground">
          The link may be old or mistyped. Here's where most people want to go:
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/">
            <Button data-testid="notfound-home" className="rounded-full bg-accent px-6 font-mono text-xs uppercase tracking-[0.2em] text-accent-foreground hover:bg-accent/90">
              Home <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/blog">
            <Button variant="outline" className="rounded-full border-border/70 px-6 font-mono text-xs uppercase tracking-[0.2em]">
              Blog
            </Button>
          </Link>
          <Link to="/docs">
            <Button variant="outline" className="rounded-full border-border/70 px-6 font-mono text-xs uppercase tracking-[0.2em]">
              Docs
            </Button>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
